import { useEffect, useRef, useState } from 'react'

import rocketChatModel from '@/core/models/rocket-chat.model'

export function useRocketChatIframe() {
  const iframeRef = useRef<HTMLIFrameElement>(null)
  const isFirstLoggedInRef = useRef<boolean>(false)

  const [isLoggedIn, setIsLoggedIn] = useState<boolean>(false)
  const [isReady, setIsReady] = useState<boolean>(false)

  useEffect(() => {

    function iframeEventHandler(messageEvent: MessageEvent) {
      const eventName = messageEvent.data.eventName
      const iframeElement = iframeRef.current
      switch (eventName) {
        case 'startup':
          setIsReady(messageEvent.data.data)
          break
        // custom event name added by Custom script logged in
        case 'logged-in':
          if (!isFirstLoggedInRef.current) isFirstLoggedInRef.current = true
          setIsLoggedIn(true)
          break
        // custom event name added by Custom script logged out
        case 'logged-out':
          setIsLoggedIn(false)
          if (!isFirstLoggedInRef.current && !!iframeElement) {
            // exception for using api outside of redux-saga
            (async () => {
              try {
                const loginToken: string = await rocketChatModel.login()
                iframeElement.contentWindow?.postMessage({
                  externalCommand: 'login-with-token',
                  token: loginToken,
                }, '*')
              } catch {
                iframeElement.contentWindow?.postMessage({
                  externalCommand: 'call-custom-oauth-login',
                  service: 'keycloaklocal'
                }, '*')
              }
            })()
          }
          break
        default:
          break
      }
    }

    window.addEventListener('message', iframeEventHandler)

    return () => {
      window.removeEventListener('message', iframeEventHandler)
    }
  }, [])

  return {
    isLoggedIn,
    isReady,
    ref: iframeRef
  }
}
